import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// In index.js or App.js
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "./ThemeContext.js";
import Font from "./Theme/Font.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store.js";
import { GoogleOAuthProvider } from "@react-oauth/google";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "your-google-client-id.apps.googleusercontent.com";

// Suppress harmless ResizeObserver loop dev overlay errors
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
    const resizeObserverErrDiv = document.getElementById("webpack-dev-server-client-overlay");
    if (resizeObserverErrDiv) {
      resizeObserverErrDiv.style.display = "none";
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Provider store={store}>
        <BrowserRouter>
          <ThemeProvider theme={Font}>
            <CssBaseline />
            <App />

            <ToastContainer
              position="top-right"
              autoClose={5000} // Toast will auto-close after 5 seconds
              hideProgressBar={true} // Hide progress bar
              newestOnTop={true} // Show the newest toast on top
              closeOnClick // Close toast when clicked
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </ThemeProvider>
        </BrowserRouter>
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(// console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";

// import CssBaseline from "@mui/material/CssBaseline";
// import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
// import { ThemeProvider as CustomThemeProvider } from "./ThemeContext"; // 🌙
// import Font from "./Theme/Font.js"; // 🎨 your MUI theme
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { BrowserRouter } from "react-router-dom";
// import { Provider } from "react-redux";
// import store from "./store/store.js";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <MUIThemeProvider theme={Font}>
//         <CustomThemeProvider>
//           {" "}

//           <CssBaseline />
//           <Provider store={store}>
//             <App />
//           </Provider>
//           <ToastContainer
//             position="top-right"
//             autoClose={5000}
//             hideProgressBar={true}
//             newestOnTop={true}
//             closeOnClick
//             pauseOnFocusLoss
//             draggable
//             pauseOnHover
//           />
//         </CustomThemeProvider>
//       </MUIThemeProvider>
//     </BrowserRouter>
//   </React.StrictMode>
// );

// reportWebVitals();
